import React, { useContext, useEffect, useState } from "react";

import { useAppStore } from "../../../../../context/store";
import { Dialog, Portal, CloseButton, Button, Input, Spinner } from "@chakra-ui/react";
import { removeFileExtension, showToast } from "../../../../../utilies/Utility";
import { loadGeojsonTypeAsync } from "../../../../../utilies/loader/LoadGeojson";
import { deleteAsset } from "../../../../../utilies/GeojsonUtility";
import Type from "../../../../../utilies/Types";
import { useMapObjects } from "../../../../../context/MapObjectsContext";
const LayersSwitch = () => {
  // state
  const showSwitchLayerDialog = useAppStore((s) => s.showSwitchLayerDialog);
  const currentLayer = useAppStore((s) => s.currentLayer);
 const { mapObjects, setMapObjects, mapObjectsRef } = useMapObjects();
  const defaultGeojsonStyle = useAppStore((s) => s.defaultGeojsonStyle);
  const basicGeojsonStyle = useAppStore((s) => s.basicGeojsonStyle);
  const defaultOsmStyle = useAppStore((s) => s.defaultOsmStyle);

  // refs
  const viewerRef = useAppStore.getState().viewerRef;
  const originalCameraControls = useAppStore.getState().originalCameraControls;

  // setters
  const setShowSwitchLayerDialog = useAppStore.getState().setShowSwitchLayerDialog;

  const setImageGeojsonMode = useAppStore.getState().setImageGeojsonMode;
  const setCamera = useAppStore.getState().setCamera;
  const setCurrentLayer = useAppStore.getState().setCurrentLayer;

  const [fileName, setFileName] = useState("");
  const [isProgress, setIsProgress] = useState(false);

  useEffect(() => {
    if (showSwitchLayerDialog && currentLayer) {
      setFileName(removeFileExtension(currentLayer.file_name));
    }
  }, [showSwitchLayerDialog, currentLayer]);

  const switchLayer = () => {
    setIsProgress(true);

    const url = "https://matrix.gatik.ai/static/layers/" + fileName + ".geojson";
    fetch(url)
      .then((response) => {
        if (!response.ok) {
        }
        return response.json();
      })
      .then((data) => {
        if (data) {
          loadGeojsonTypeAsync({
            originalCameraControls,
            geojsonData: data,
            fileName: fileName,
            viewerRef,
            setMapObjects,
            defaultGeojsonStyle,
            basicGeojsonStyle,
            isUrl: true,
            defaultOsmStyle,
            isEdited: false,
            projectId: currentLayer.project_id,
          });

          deleteAsset(viewerRef.current, currentLayer, [mapObjects, setMapObjects], setImageGeojsonMode, setCamera);
          setIsProgress(false);
          setShowSwitchLayerDialog(false);
          showToast("Switched", Type.NOTIFICATION.SUCCESS);
        }
      })
      .catch((error) => {
        console.error(error);
        showToast(error.message, Type.NOTIFICATION.ERROR);
        setIsProgress(false);
      });
  };

  return (
    <Dialog.Root
      lazyMount
      open={showSwitchLayerDialog}
      closeOnInteractOutside={false}
      onOpenChange={(e) => {
        setShowSwitchLayerDialog(e.open);
        if (!Boolean(e.open)) {
          setCurrentLayer(null);
        }
      }}
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header>
              <Dialog.Title>Save To Server</Dialog.Title>
            </Dialog.Header>
            <Dialog.Body>
              <Input
                placeholder="Enter name"
                value={fileName}
                onChange={(v) => {
                  setFileName(v.target.value);
                }}
              />
            </Dialog.Body>
            <Dialog.Footer>
              <Dialog.ActionTrigger asChild>
                <Button variant="outline">Cancel</Button>
              </Dialog.ActionTrigger>
              <Button onClick={switchLayer}>{isProgress ? <Spinner size="sm" /> : "Switch"}</Button>
            </Dialog.Footer>
            <Dialog.CloseTrigger asChild>
              <CloseButton size="sm" />
            </Dialog.CloseTrigger>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default LayersSwitch;
